import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M19 22v-6m0 0l3 3m-3 -3l-3 3","key":"svg-3"}]]

const IconFilter2Up = createReactComponent('outline', 'filter-2-up', 'Filter2Up', __iconNode);

export default IconFilter2Up;